export default function EnrollmentIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="12" fill="#DDDFFF" />
      <path
        d="M23 10.4578C22.053 10.1603 21.0452 10 20 10C14.4771 10 10 14.4771 10 20C10 25.5228 14.4771 30 20 30C25.5228 30 30 25.5228 30 20C30 18.9548 29.8396 17.947 29.5422 17"
        stroke="#4C56BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 18C23 19.6569 21.6569 21 20 21C18.3431 21 17 19.6569 17 18C17 16.3432 18.3431 15 20 15C21.6569 15 23 16.3432 23 18Z"
        stroke="#4C56BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 27.5001L14.0604 26.5194C14.9506 24.9616 16.6073 24.0001 18.4017 24.0001H21.5984C23.3927 24.0001 25.0494 24.9616 25.9396 26.5194L26.5 27.5001"
        stroke="#4C56BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.9737 10.0215C26.9795 9.99284 27.0205 9.99284 27.0263 10.0215C27.3302 11.5081 28.4919 12.6698 29.9785 12.9737C30.0072 12.9795 30.0072 13.0205 29.9785 13.0263C28.4919 13.3302 27.3302 14.4919 27.0263 15.9785C27.0205 16.0072 26.9795 16.0072 26.9737 15.9785C26.6698 14.4919 25.5081 13.3302 24.0215 13.0263C23.9928 13.0205 23.9928 12.9795 24.0215 12.9737C25.5081 12.6698 26.6698 11.5081 26.9737 10.0215Z"
        stroke="#4C56BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
